import React from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { SubTitle, Title } from "@minerva-analytics/pantheon";
import SubscribeForm from "../../components/SubscribeForm";
import SubscribeJump from "../../components/SubscribeJump";
import {
  HeroContainer,
  HomeContainer,
  ImageContainer,
  Image,
} from "./Home.styles";

const Home = () => {
  const status = useSelector(
    (state) => state.subscription.createSubscriberStatus
  );
  const success = status.loaded && !status.failed;
  return (
    <>
      <Helmet>
        <title>
          Daily International Recipe Newsletter | Cooking & Cocktails
        </title>
        <meta
          name="og:title"
          property="og:title"
          content="Daily International Recipe Newsletter | Cooking & Cocktails"
        />
        <meta
          name="og:description"
          property="og:description"
          content="Want to get a new international recipe delivered to your inbox every day? Sign up for our free email newsletter!"
        />
        <meta
          name="description"
          property="description"
          content="Want to get a new international recipe delivered to your inbox every day? Sign up for our free email newsletter!"
        />
      </Helmet>
      <HomeContainer>
        <HeroContainer>
          {success ? (
            <SubscribeJump />
          ) : (
            <>
              <Title>International Recipes Delivered Daily!</Title>
              <SubTitle>
                Discover delicious recipes from countries all over the world
                with our free email newsletter! Every day, we’ll send you a
                recipe from a new country along with a brief story about the
                dish. This is a great way to learn about new cultures and to
                challenge yourself to prepare unfamiliar dishes! It’s also
                completely free – simply sign up for our recipe newsletter and
                we’ll send you a new international food or cocktail recipe each
                day.
              </SubTitle>
              <SubscribeForm />
            </>
          )}
        </HeroContainer>
        <ImageContainer>
          <Image />
        </ImageContainer>
      </HomeContainer>
    </>
  );
};

export default Home;
